import { API_AUTH } from ".././common";

const ThayDoiKyLaiApi = {
  saveThayDoiKyLai: (params) =>
    API_AUTH.post("quan-ly-cho-vay/thaydoikylaiHopDong", params),
  lichsuChoVayInterests: ({ chovayID, type }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/lichsuChoVayInterests?chovayId=${chovayID}&type=${type}`,
      {}
    ),
  xoaThayDoiKyLai: ({ thaydoiID }) =>
    API_AUTH.post(
      `quan-ly-cho-vay/xoathaydoikylaiHopDong?thaydoiID=${thaydoiID}`,
      {}
    ),
};
export default ThayDoiKyLaiApi;
